import React from "react"
import { Box } from "@chakra-ui/react"
 
export default function Logo(props) {
  return (
    <Box {...props}>
        <img src="/img/tyrell-yutani_loading.png" alt="Tyrell-Yutani Logo"/>
    </Box>
  )
}